module.exports = __webpack_public_path__ + "static/media/attention.4e34ce26.png";